import { useContext, useCallback } from 'react';
import {
    TranslatorContext,
    noTranslateLang,
    noTranslatePrefix,
    TranlationsBase,
} from '../../common/providers/Translations';

export type BellaTranslator = (poKey: string, parameterValues?: Array<string | number>, plural?: boolean) => string;

export const likeSprintf = (translation: string, parameters: (string | number)[]) => {
    let index = -1;
    return translation.replace(/%s|%d/g, (occ: string) => {
        index += 1;
        return <string>parameters[index] || occ;
    });
};

interface Translate {
    key: string;
    translationContext: TranlationsBase;
    parameters?: (string | number)[];
    plural?: boolean;
}

export const t = ({ key, translationContext, parameters, plural }: Translate) => {
    const { translations, language } = translationContext;
    if (language && language.toLowerCase() === noTranslateLang) {
        return `${noTranslatePrefix}[${key}]`;
    }

    let translated = !!translations && translations[key] ? translations[key] : key;

    if (parameters && parameters.length) {
        translated = likeSprintf(translated, parameters);
    }

    translated = translated.replace('%%', '%');

    if (translated.includes('|')) {
        const parts = translated.split('|');
        if (plural) {
            return parts[1];
        }
        return parts[0];
    }
    return translated;
};

const useBellaTranslator: () => BellaTranslator = () => {
    const tContext = useContext(TranslatorContext);
    return useCallback(
        (poKey, parameterValues, plural) =>
            t({
                key: poKey,
                translationContext: tContext,
                parameters: parameterValues,
                plural,
            }),
        [tContext]
    );
};

export default useBellaTranslator;
